"use strict";

//=====================
// The external world map.
//
// The pages that only DECORATE with the map (bicsearch, bictoleisearch) carry a
// `[data-map-src]` placeholder in the server-rendered document; the ~96 KiB SVG
// is fetched and injected after the window `load` event, so it never sits on the
// document's critical path. The wrapper already reserves the map's height
// (bicsearch `min-height: 600px`, bictoleisearch `aspect-ratio: 2050/900`), so
// the injection shifts no layout.
//
// The markup is injected, never an `<img>`: an `<img>` would be a new LCP
// candidate and a second network request. The SVG is this repo's own static
// template (the `map` partial), never user data.
//
// The SVG is a static asset (`@fastify/static`), so it is fetched through the
// client HTTP layer in text mode (`http.text`), with the API common headers
// suppressed: a static asset is not an `/api/*` XHR.
//=====================

const http = require("client/http_client");

function _inject (container, markup) {
    // the markup is the trusted static SVG partial
    container.innerHTML = markup;
}

function _load (container) {
    const src = container.dataset.mapSrc;
    if (!src) {
        return;
    }
    http.text(src, {noCommonHeaders: true}).then(function (response) {
        if (response.data) {
            _inject(container, response.data);
        }
    }).catch(function () {
        // a decorative map must never break the page
    });
}

function load () {
    const containers = document.querySelectorAll("[data-map-src]");
    for (const container of containers) {
        _load(container);
    }
}

module.exports = {load};
